module.exports = __webpack_public_path__ + "static/praise3.17d48290ac63e9d1c0224a07c625ac3f.png";